<template>
  <g
    id="Main_body-2"
    v-on:click="changeSeverity('frontMainBody')"
    :class="severityClass"
  >
    <path
      class="cls-611"
      d="M669.99,260.32h0v29.15h0c-3.19,0-5.77-2.59-5.77-5.77v-17.6c0-3.19,2.59-5.77,5.77-5.77Z"
      transform="translate(1334.2 549.78) rotate(180)"
    />
    <rect class="cls-419" x="633.87" y="247.46" width="27.25" height="20.73" />
    <path
      class="cls-611"
      d="M669.51,240.16v3.99c0,2.17-.56,4.22-1.54,5.99-1.63,2.94-4.42,5.16-7.76,6.02-.99,.26-2.03,.39-3.1,.39h-18.72c-.18,0-.35,0-.52-.01-2.97-.12-5.68-1.29-7.75-3.16-2.53-2.27-4.13-5.56-4.13-9.24v-3.99c0-3.68,1.6-6.98,4.15-9.25,2.08-1.86,4.78-3.02,7.76-3.14,.17,0,.33-.01,.5-.01h18.72c1.08,0,2.13,.14,3.12,.4,3.34,.86,6.13,3.08,7.75,6.04,.98,1.77,1.53,3.8,1.53,5.97Z"
    />
    <rect class="cls-614" x="631.74" y="224.19" width="32.01" height="25.14" />
    <path
      class="cls-471"
      d="M634.12,293.62h5.1v29.15h-5.1c-3.33,0-6.03-2.7-6.03-6.03v-17.09c0-3.33,2.7-6.03,6.03-6.03Z"
    />
    <path
      class="cls-471"
      d="M662.3,293.62h5.1v29.15h-5.1c-3.33,0-6.03-2.7-6.03-6.03v-17.09c0-3.33,2.7-6.03,6.03-6.03Z"
      transform="translate(1323.67 616.38) rotate(180)"
    />
    <path
      class="cls-883"
      d="M636.2,295.29h.56v21.83h-.56c-2.88,0-5.22-2.34-5.22-5.22v-11.39c0-2.88,2.34-5.22,5.22-5.22Z"
    />
    <circle class="cls-939" cx="631.77" cy="324.19" r="6.95" />
    <path
      class="cls-885"
      d="M631.15,326.55h0c-1.37-.32-2.21-1.68-1.89-3.05l11.92-51.02c.32-1.37,1.68-2.21,3.05-1.89h0c1.37,.32,2.21,1.68,1.89,3.05l-11.92,51.02c-.32,1.37-1.68,2.21-3.05,1.89Z"
    />
    <g>
      <g>
        <path
          class="cls-204"
          d="M630.88,329.01c-1.92,0-3.71-1.06-4.62-2.79l-6.85-13.06,1.42-.75,6.85,13.06c.71,1.35,2.2,2.11,3.71,1.9l14.55-2.08,.23,1.59-14.55,2.08c-.25,.04-.49,.05-.74,.05Z"
        />
        <path
          class="cls-584"
          d="M619.48,313.19l.53-.28,.83-.33,6.6,12.57s.2,.37,.21,.39c.72,1.33,2.18,2.08,3.68,1.89,.02,0,.56-.08,.58-.08l13.87-1.98,.23,.85,.09,.6-14.49,2.07c-.24,.03-.49,.05-.73,.05-1.9,0-3.67-1.05-4.57-2.76l-6.82-13Z"
        />
        <path
          class="cls-431"
          d="M619.57,313.21l.52-.27,.78-.19,6.55,12.47s.19,.36,.21,.38c.72,1.31,2.16,2.05,3.65,1.89,.04,0,.54-.07,.58-.07l13.78-1.97,.31,.73,.08,.6-14.43,2.06c-.24,.03-.48,.05-.72,.05-1.88,0-3.63-1.04-4.51-2.73l-6.8-12.95Z"
        />
        <path
          class="cls-496"
          d="M619.65,313.24l.51-.27,.73-.05,6.5,12.38s.18,.34,.21,.38c.73,1.29,2.15,2.03,3.63,1.88,.06,0,.52-.06,.58-.07l13.68-1.96,.4,.61,.08,.59-14.37,2.06c-.24,.03-.47,.05-.71,.05-1.86,0-3.59-1.03-4.46-2.7l-6.77-12.9Z"
        />
        <path
          class="cls-629"
          d="M619.73,313.26l.51-.27,.67,.09,6.45,12.28c.03,.06,.17,.32,.21,.38,.73,1.26,2.13,2,3.6,1.88,.09,0,.49-.05,.58-.06l13.59-1.94,.48,.48,.08,.58-14.31,2.05c-.23,.03-.47,.05-.7,.05-1.84,0-3.54-1.02-4.41-2.66l-6.74-12.85Z"
        />
        <path
          class="cls-503"
          d="M619.81,313.29l.5-.26,.62,.23,6.4,12.18c.04,.07,.17,.31,.21,.37,.74,1.24,2.12,1.97,3.57,1.88,.11,0,.47-.04,.58-.06l13.49-1.93,.57,.36,.08,.57-14.26,2.04c-.23,.03-.46,.05-.69,.05-1.82,0-3.5-1.01-4.36-2.63l-6.71-12.79Z"
        />
        <path
          class="cls-595"
          d="M619.89,313.31l.49-.26,.57,.37,6.34,12.09c.04,.08,.16,.29,.21,.37,.75,1.22,2.1,1.94,3.54,1.87,.13,0,.45-.04,.58-.05l13.4-1.92,.65,.24,.08,.56-14.2,2.03c-.23,.03-.46,.05-.69,.05-1.8,0-3.46-.99-4.3-2.6l-6.69-12.74Z"
        />
        <path
          class="cls-643"
          d="M619.97,313.34l.49-.26,.52,.51,6.29,11.99c.05,.1,.15,.28,.21,.37,.75,1.2,2.09,1.91,3.52,1.87,.15,0,.43-.03,.58-.05l13.3-1.9,.74,.12,.08,.55-14.14,2.02c-.22,.03-.45,.05-.68,.05-1.78,0-3.42-.98-4.25-2.57l-6.66-12.69Z"
        />
        <path
          class="cls-22"
          d="M620.05,313.36l.48-.25,.46,.64,6.24,11.9c.06,.11,.14,.26,.21,.36,.76,1.18,2.07,1.89,3.49,1.86,.17,0,.41-.02,.58-.05l13.2-1.89h.83s.08,.53,.08,.53l-14.08,2.01c-.22,.03-.45,.05-.67,.05-1.77,0-3.38-.97-4.2-2.54l-6.63-12.63Z"
        />
        <path
          class="cls-485"
          d="M630.88,328.47c-1.75,0-3.34-.96-4.15-2.51l-6.6-12.58,.47-.25,6.6,12.58c.72,1.37,2.13,2.22,3.67,2.22,.19,0,.39-.01,.58-.04l14.02-2,.08,.53-14.02,2c-.22,.03-.44,.05-.66,.05Z"
        />
      </g>
      <rect
        class="cls-419"
        x="614.18"
        y="311.32"
        width="12.95"
        height="2.93"
        rx="1.02"
        ry="1.02"
      />
    </g>
    <g>
      <g>
        <path
          class="cls-204"
          d="M664.61,329.01c1.92,0,3.71-1.06,4.62-2.79l6.85-13.06-1.42-.75-6.85,13.06c-.71,1.35-2.2,2.11-3.71,1.9l-14.55-2.08-.23,1.59,14.55,2.08c.25,.04,.49,.05,.74,.05Z"
        />
        <path
          class="cls-584"
          d="M676,313.19l-.53-.28-.83-.33-6.6,12.57s-.2,.37-.21,.39c-.72,1.33-2.18,2.08-3.68,1.89-.02,0-.56-.08-.58-.08l-13.87-1.98-.23,.85-.09,.6,14.49,2.07c.24,.03,.49,.05,.73,.05,1.9,0,3.67-1.05,4.57-2.76l6.82-13Z"
        />
        <path
          class="cls-431"
          d="M675.92,313.21l-.52-.27-.78-.19-6.55,12.47s-.19,.36-.21,.38c-.72,1.31-2.16,2.05-3.65,1.89-.04,0-.54-.07-.58-.07l-13.78-1.97-.31,.73-.08,.6,14.43,2.06c.24,.03,.48,.05,.72,.05,1.88,0,3.63-1.04,4.51-2.73l6.8-12.95Z"
        />
        <path
          class="cls-496"
          d="M675.84,313.24l-.51-.27-.73-.05-6.5,12.38s-.18,.34-.21,.38c-.73,1.29-2.15,2.03-3.63,1.88-.06,0-.52-.06-.58-.07l-13.68-1.96-.4,.61-.08,.59,14.37,2.06c.24,.03,.47,.05,.71,.05,1.86,0,3.59-1.03,4.46-2.7l6.77-12.9Z"
        />
        <path
          class="cls-629"
          d="M675.76,313.26l-.51-.27-.67,.09-6.45,12.28c-.03,.06-.17,.32-.21,.38-.73,1.26-2.13,2-3.6,1.88-.09,0-.49-.05-.58-.06l-13.59-1.94-.48,.48-.08,.58,14.31,2.05c.23,.03,.47,.05,.7,.05,1.84,0,3.54-1.02,4.41-2.66l6.74-12.85Z"
        />
        <path
          class="cls-503"
          d="M675.68,313.29l-.5-.26-.62,.23-6.4,12.18c-.04,.07-.17,.31-.21,.37-.74,1.24-2.12,1.97-3.57,1.88-.11,0-.47-.04-.58-.06l-13.49-1.93-.57,.36-.08,.57,14.26,2.04c.23,.03,.46,.05,.69,.05,1.82,0,3.5-1.01,4.36-2.63l6.71-12.79Z"
        />
        <path
          class="cls-595"
          d="M675.6,313.31l-.49-.26-.57,.37-6.34,12.09c-.04,.08-.16,.29-.21,.37-.75,1.22-2.1,1.94-3.54,1.87-.13,0-.45-.04-.58-.05l-13.4-1.92-.65,.24-.08,.56,14.2,2.03c.23,.03,.46,.05,.69,.05,1.8,0,3.46-.99,4.3-2.6l6.69-12.74Z"
        />
        <path
          class="cls-643"
          d="M675.52,313.34l-.49-.26-.52,.51-6.29,11.99c-.05,.1-.15,.28-.21,.37-.75,1.2-2.09,1.91-3.52,1.87-.15,0-.43-.03-.58-.05l-13.3-1.9-.74,.12-.08,.55,14.14,2.02c.22,.03,.45,.05,.68,.05,1.78,0,3.42-.98,4.25-2.57l6.66-12.69Z"
        />
        <path
          class="cls-22"
          d="M675.44,313.36l-.48-.25-.46,.64-6.24,11.9c-.06,.11-.14,.26-.21,.36-.76,1.18-2.07,1.89-3.49,1.86-.17,0-.41-.02-.58-.05l-13.2-1.89h-.83s-.08,.53-.08,.53l14.08,2.01c.22,.03,.45,.05,.67,.05,1.77,0,3.38-.97,4.2-2.54l6.63-12.63Z"
        />
        <path
          class="cls-485"
          d="M664.61,328.47c1.75,0,3.34-.96,4.15-2.51l6.6-12.58-.47-.25-6.6,12.58c-.72,1.37-2.13,2.22-3.67,2.22-.19,0-.39-.01-.58-.04l-14.02-2-.08,.53,14.02,2c.22,.03,.44,.05,.66,.05Z"
        />
      </g>
      <rect
        class="cls-419"
        x="668.49"
        y="311.32"
        width="12.95"
        height="2.93"
        rx="1.02"
        ry="1.02"
        transform="translate(1349.92 625.57) rotate(180)"
      />
    </g>
    <ellipse class="cls-870" cx="647.79" cy="215" rx="8.48" ry="4.58" />
    <g>
      <path
        class="cls-471"
        d="M635.96,217.01s5.43-5.97,11.79-5.97v5.84l-11.79,4.34v-4.21Z"
      />
      <path
        class="cls-471"
        d="M659.53,217.01s-5.43-5.97-11.79-5.97v5.84l11.79,4.34v-4.21Z"
      />
      <path
        class="cls-472"
        d="M659.53,217.01s-5.43-5.97-11.79-5.97v5.84l11.79,4.34v-4.21Z"
      />
    </g>
    <g class="cls-738">
      <path
        class="cls-532"
        d="M667.35,239.67c.39,.18,.62,.4,.62,.62,0,.01,0,.03,0,.04,0,.01,0,.03,0,.04v9.79c-1.63,2.94-4.42,5.16-7.76,6.02v-15.82s0-.03,.01-.04c0-.01,0-.02,0-.03,0-.22,.23-.44,.62-.62-.33-.16-.54-.34-.59-.53-.01-.03-.03-.05-.02-.09v-10.89c3.35,.86,6.14,3.08,7.76,6.04v4.86s-.02,.09-.05,.12c-.07,.18-.27,.34-.58,.48Z"
      />
      <path
        class="cls-532"
        d="M637.25,239.67c.39,.18,.62,.4,.62,.62,0,.01,0,.03,0,.04,0,.01,0,.03,0,.04v16.19c-2.98-.12-5.68-1.29-7.76-3.16v-13.04s0-.03,.01-.04c0-.01,0-.02,0-.03,0-.22,.23-.44,.62-.62-.33-.16-.54-.34-.59-.53-.01-.03-.03-.05-.02-.09v-8.14c2.09-1.86,4.79-3.02,7.77-3.14l-.02,11.29s-.02,.09-.04,.12c-.07,.18-.27,.34-.58,.48Z"
      />
    </g>
    <path
      class="cls-611"
      d="M631.28,260.32h0v29.15h0c-3.19,0-5.77-2.59-5.77-5.77v-17.6c0-3.19,2.59-5.77,5.77-5.77Z"
    />
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
